module.exports = __webpack_public_path__ + "static/media/fullPageSpinner.10d57447.gif";